import { Checkbox, FormControlLabel, Typography } from '@mui/material'
import parse from 'html-react-parser'
import rehypeStringify from 'rehype-stringify'
import remarkParse from 'remark-parse'
import remarkRehype from 'remark-rehype'
import { unified } from 'unified'

export const FormBooleanPrint = ({
  id,
  title,
  value,
  disabled,
  typeProps,
  langVersion,
  labelAsMarkdown,
  ...props
}) => {
  if (labelAsMarkdown) {
    title = unified()
      .use(remarkParse)
      .use(remarkRehype, { allowDangerousHtml: true })
      .use(rehypeStringify, { allowDangerousHtml: true })
      .processSync(title)
      .toString()
  }

  return (
    <FormControlLabel
      control={<Checkbox disabled checked={Boolean(value)} />}
      label={<Typography className='form-read-only-text'>{parse(title)}</Typography>}
    />
  )
}
